import { createFeatureActionNamer } from '../../../../redux/action-name';

const getActionName = createFeatureActionNamer('ra-death-assessment-decision');

export const ADD_RA_DEATH_DECISION = getActionName('ADD_RA_DEATH_DECISION');
